export default "__VITE_ASSET__k_nTlgKr__"